import React from 'react';
import { object, bool, string } from 'prop-types';
import { Layout } from '@fiverr-private/layout_components';
import { TitleSection } from '../gigs/GigsComponentsWrapper/CarouselHeader/TitleSection';
import {
    selectedTabButtonStyles,
    selectTabTitleMobile,
    tabTitleFontStyles,
    tabTitleStyles,
} from './TabsView.styles.ve.css';
import { convertLeanPropertiesToTitleSections } from './utils';

const TabTitle = (props) => {
    const { component, isSelectedTab, mobileView, variant } = props;

    const isProPcpVariant = variant === 'pro_pcp';

    convertLeanPropertiesToTitleSections(component);

    const { titleSections, metadata } = component?.properties ?? {};
    const serviceId = metadata?.service_id;
    const componentDataSource = metadata?.component_data_source;

    return mobileView ? (
        <TitleSection
            textWrapperClassname={isSelectedTab ? selectTabTitleMobile : tabTitleFontStyles}
            withIcon={false}
            textSections={titleSections}
            serviceId={serviceId}
            componentDataSource={componentDataSource}
        />
    ) : (
        <Layout
            role="tab"
            width="262px"
            paddingTop="4"
            paddingBottom="4"
            paddingLeft="3"
            paddingRight="3"
            borderRadius="lg"
            display="inlineFlex"
            justifyContent="flexStart"
            backgroundColor={{
                hover: 'grey_200',
                ...(isSelectedTab && { default: 'grey_200' }),
            }}
            outlineColor={isSelectedTab && !isProPcpVariant ? 'grey_1200' : 'transparent'}
            className={isSelectedTab && selectedTabButtonStyles}
        >
            <TitleSection
                textWrapperClassname={tabTitleStyles}
                textSections={titleSections}
                serviceId={serviceId}
                componentDataSource={componentDataSource}
            />
        </Layout>
    );
};

export default TabTitle;

TabTitle.propTypes = {
    component: object,
    isSelectedTab: bool,
    mobileView: bool,
    variant: string,
};
